// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cispro-dialog-title {
  font-family: 'Gotham Narrow', sans-serif;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 12px 16px 8px;
}

.cispro-dialog-content {
  min-width: 380px;
  padding: 8px 16px;
}

.cispro-empty-msg {
  color: #555;
  font-size: 0.9rem;
  margin-bottom: 8px;
}

.cispro-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}

.cispro-input {
  flex: 1;
  height: 32px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 0.9rem;
}

/* Matches spacer-details .delete-btn */
.delete-btn {
  color: #c0392b;
  font-weight: bold;
  padding: 0 4px;
  line-height: 1;
  font-size: 12px;
  border: none;
  background: transparent;
  flex-shrink: 0;
}

.delete-btn:hover {
  color: #a93226;
}

/* Matches spacer-details .small-icon */
.small-icon {
  font-size: 16px;
  line-height: 16px;
  width: 16px;
  height: 16px;
}

.btn {
  padding: 0.25rem 0.5rem;
  flex-shrink: 0;
}

.cispro-dialog-actions {
  display: flex;
  gap: 8px;
  padding: 8px 16px 12px;
  justify-content: flex-start;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/spacer-cispro-containers-dialog/spacer-cispro-containers-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,uCAAuC;AACvC;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,sBAAsB;EACtB,2BAA2B;AAC7B","sourcesContent":[".cispro-dialog-title {\n  font-family: 'Gotham Narrow', sans-serif;\n  font-weight: bold;\n  font-size: 1.1rem;\n  padding: 12px 16px 8px;\n}\n\n.cispro-dialog-content {\n  min-width: 380px;\n  padding: 8px 16px;\n}\n\n.cispro-empty-msg {\n  color: #555;\n  font-size: 0.9rem;\n  margin-bottom: 8px;\n}\n\n.cispro-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 8px;\n}\n\n.cispro-input {\n  flex: 1;\n  height: 32px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  padding: 0 8px;\n  font-size: 0.9rem;\n}\n\n/* Matches spacer-details .delete-btn */\n.delete-btn {\n  color: #c0392b;\n  font-weight: bold;\n  padding: 0 4px;\n  line-height: 1;\n  font-size: 12px;\n  border: none;\n  background: transparent;\n  flex-shrink: 0;\n}\n\n.delete-btn:hover {\n  color: #a93226;\n}\n\n/* Matches spacer-details .small-icon */\n.small-icon {\n  font-size: 16px;\n  line-height: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.btn {\n  padding: 0.25rem 0.5rem;\n  flex-shrink: 0;\n}\n\n.cispro-dialog-actions {\n  display: flex;\n  gap: 8px;\n  padding: 8px 16px 12px;\n  justify-content: flex-start;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
